(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-safety-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const select = (root, key, focus) => {
      root.querySelectorAll('[data-sm-tab]').forEach((tab) => {
        const selected = tab.dataset.smTab === key;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (selected && focus) tab.focus();
      });
      root.querySelectorAll('[data-sm-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.smPanel !== key;
      });
    };

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-sm-tab]');
      const root = tab && tab.closest('[data-safety-modal]');
      if (root) select(root, tab.dataset.smTab, false);
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest && event.target.closest('[data-sm-tab]');
      const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
      const root = tab && direction && tab.closest('[data-safety-modal]');
      if (!root) return;
      event.preventDefault();
      const tabs = Array.from(root.querySelectorAll('[data-sm-tab]'));
      const next = tabs[(tabs.indexOf(tab) + direction + tabs.length) % tabs.length];
      select(root, next.dataset.smTab, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
